/**
 * Represents the mode of color transformation
 */
// eslint-disable-next-line etc/no-const-enum
export var ColorTransformDirection;
(function (ColorTransformDirection) {
    /**
     * Transform from light to dark
     */
    ColorTransformDirection[ColorTransformDirection["LightToDark"] = 0] = "LightToDark";
    /**
     * Transform from dark to light
     */
    ColorTransformDirection[ColorTransformDirection["DarkToLight"] = 1] = "DarkToLight";
})(ColorTransformDirection || (ColorTransformDirection = {}));
//# sourceMappingURL=ColorTransformDirection.js.map